// extracted by mini-css-extract-plugin
export default {"warning":"VerificationWarning_warning__e-oeU"};